import React from 'react';
import { createContext } from 'react';
import { AuthUser } from '../types';
import { FirebaseApp } from 'firebase/app';

export const AuthContext = createContext<{
  user: AuthUser | null;
  setUser: React.Dispatch<React.SetStateAction<AuthUser | null>>;
  isInitializing: boolean;
  setIsInitializing: React.Dispatch<React.SetStateAction<boolean>>;
  firebaseApp: FirebaseApp;
}>({
  user: null,
  setUser: () => {},
  isInitializing: true,
  setIsInitializing: () => {},
  firebaseApp: null as any,
});
